import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { C } from "./theme/colors";
import { injectStyles } from "./utils/styles";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import StakeholdersPage from "./pages/StakeholdersPage";
import ResearchPage from "./pages/ResearchPage";
import MissionPage from "./pages/MissionPage";
import TrainingPage from "./pages/TrainingPage";
import ObjectivesPage from "./pages/ObjectivesPage";
import WayForwardPage from "./pages/WayForwardPage";
import EventsPage from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import ContactPage from "./pages/ContactPage";
import Media from "./pages/Media";

// Scrolls to top on every route change (replaces your old page-change effect)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

function AppLayout() {
  useEffect(() => { injectStyles(); }, []);

  return (
    <div style={{minHeight:"100vh",background:C.bg}}>
      <ScrollToTop/>
      <Navbar/>
      <main style={{paddingTop:66}}>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/about" element={<AboutPage/>}/>
          <Route path="/stakeholders" element={<StakeholdersPage/>}/>
          <Route path="/research" element={<ResearchPage/>}/>
          <Route path="/mission" element={<MissionPage/>}/>
          <Route path="/training" element={<TrainingPage/>}/>
          <Route path="/training/:subpage" element={<TrainingPage/>}/>
          <Route path="/objectives" element={<ObjectivesPage/>}/>
          <Route path="/way-forward" element={<WayForwardPage/>}/>
          <Route path="/events" element={<EventsPage/>}/>
          <Route path="/events/:eventId" element={<EventDetailPage/>}/>
          <Route path="/contact" element={<ContactPage/>}/>
          {/* Fallback: unknown URL goes to Home */}
          <Route path="*" element={<HomePage/>}/>
          <Route path="/Media" element={<Media />} />
          
        </Routes>
      </main>
      <Footer/>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout/>
    </BrowserRouter>
  );
}